import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { Images } from "../../assets/common";
import "./index.scss";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import TipPopup from "../TipPopup";
import { fullName, getErrorString, isOwnerId } from "../../constants/function";
import NoData from "./../../components/Nodata";
import ApiService from "./../../services/api-service";
import notifier from "./../../components/Notifier";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";
import Loader from "./../../components/Loader";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
export default function ChatTip({ songs, onClose, playlistId }) {
  const { t } = useTranslation("common");
  const [playlistSongs, setPlaylistSongs] = React.useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [tipIndex, setTipIndex] = useState(null);
  const [msg, setMsg] = useState("loading songs...");
  const history = useHistory();
  const handleTipPopup = (index) => {
    if (index != null) {
      setTipIndex(index);
      setOpen(!open);
    }
  };
  const getName = () => {
    if (songs.length > 0)
      return songs[tipIndex]["artist"]
        ? songs[tipIndex]["artist"]
        : fullName(
            songs[tipIndex]["owner"]
              ? songs[tipIndex]["owner"]
              : songs[tipIndex]["uploader"]
              ? songs[tipIndex]["uploader"]
              : ""
          );
    else
      return playlistSongs[tipIndex]["artist"]
        ? playlistSongs[tipIndex]["artist"]
        : fullName(
            playlistSongs[tipIndex]["owner"]
              ? playlistSongs[tipIndex]["owner"]
              : playlistSongs[tipIndex]["uploader"]
              ? playlistSongs[tipIndex]["uploader"]
              : ""
          );
  };
  const handleClose = async (amount, id, type, currency) => {
    if (amount) {
      setOpen(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        console.log('Sending tip with payload:', payload);
        setLoading(true);
        setMsg("sending tip...");
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        setMsg("");
        notifier.success(response["result"]);

        dispatch(getBalance());
      } catch (error) {
        console.error('Tip error:', error);
        console.error('Error response:', error.response);
        setLoading(false);
        notifier.error(getErrorString(error));
        setMsg("");
      }
    } else {
      setOpen(false);
    }
  };
  React.useEffect(() => {
    if (playlistId) {
      getPlaylistSongs(playlistId);
    }
  }, []);

  const getPlaylistSongs = async (playlistId) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: playlistId,
        pageNo: 1,
        pageSize: 100,
      });

      setLoading(false);

      setPlaylistSongs([...response["result"]["music"]]);
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Box className="__chat_tip_container">
      <Stack
        className="_chat_tip_box_header"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <img
            style={{ width: "38px" }}
            src={Images.chat_playlist}
            alt="subscription"
          />
          <Typography className="fs-15">Send tip to playlist</Typography>
        </Stack>
        <img
          title="Close"
          style={{ width: "12px", height: "12px" }}
          src={Images.arrow_down}
          className="_cp"
          onClick={() => onClose()}
          alt="close"
        />
      </Stack>

      <Stack
        spacing={1}
        className={songs ? "_chat_tip_box" : "_chat_tip_box_hide"}
      >
        {songs.length > 0 ? (
          songs.map((song, index) => (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              spacing={1}
              className={
                "_cp " +
                (tipIndex === index && open
                  ? "__playlist_chat_song_selected"
                  : "")
              }
              onClick={() =>
                !isOwnerId(
                  song["owner"]
                    ? song["owner"]["_id"]
                    : song["uploader"]
                    ? song["uploader"]["_id"]
                    : ""
                )
                  ? handleTipPopup(index)
                  : handleTipPopup(null)
              }
            >
              <img
                className="avatar"
                src={song["thumbnailImg"]["filePath"]}
                alt="song"
              />
              <Stack direction="column">
                <Typography className="fs-14 text-capitalize">
                  {song["title"]}
                </Typography>
                <Stack
                  direction="row"
                  style={{
                    overflowY: "scroll",
                    width: song["artistData"]?.length > 2 ? "62%" : "",
                    gap: "5px",
                  }}
                >
                  {song["artistData"] ? (
                    song["artistData"].length > 1 ? (
                      song["artistData"].map((a, index) => (
                        <Typography
                          onClick={() =>
                            history.push(`/app/ArtistProfile/${a.uId}`)
                          }
                          variant="body2"
                          className="fs-14 fade-text _cp"
                          key={index}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {a?.displayArtistName}
                          {song["artistData"].length - 1 == index ? "" : ","}
                        </Typography>
                      ))
                    ) : (
                      song["artistData"].map((a, index) => (
                        <Typography
                          onClick={() =>
                            history.push(`/app/ArtistProfile/${a.uId}`)
                          }
                          variant="body2"
                          className="fs-14 fade-text _cp"
                          key={index}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {a?.displayArtistName}
                        </Typography>
                      ))
                    )
                  ) : (
                    <Typography className="fs-13 fade-text-60">
                      {song["artist"].replace(/\//g, ", ")}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Stack>
          ))
        ) : playlistSongs.length > 0 ? (
          playlistSongs.map((song, index) => (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              spacing={1}
              className={
                "_cp " +
                (tipIndex === index && open
                  ? "__playlist_chat_song_selected"
                  : "")
              }
              onClick={() =>
                !isOwnerId(
                  song["owner"]
                    ? song["owner"]["_id"]
                    : song["uploader"]
                    ? song["uploader"]["_id"]
                    : ""
                )
                  ? handleTipPopup(index)
                  : handleTipPopup(null)
              }
            >
              <img
                className="avatar"
                src={song["thumbnailImg"]["filePath"]}
                alt="song"
              />
              <Stack direction="column">
                <Typography className="fs-14 text-capitalize">
                  {song["title"]}
                </Typography>
                <Typography className="fs-13 fade-text-60">
                  {song["artist"]}
                </Typography>
              </Stack>
            </Stack>
          ))
        ) : (
          <Box sx={{ position: "relative" }}>
            <NoData lable={t("noData.noData")} />
          </Box>
        )}
      </Stack>

      {open ? (
        <TipPopup
          artist={getName()}
          id={
            songs.length > 0
              ? songs[tipIndex]["_id"]
              : playlistSongs[tipIndex]["_id"]
          }
          open={open}
          isArtist={false}
          handleClose={(amount, id, type, currency) =>
            !id ? setOpen(false) : handleClose(amount, id, type, currency)
          }
          backdropOff={true}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={`${t("loader.message9")} ${msg}`}
        />
      ) : null}
    </Box>
  );
}
